import React from 'react';
import t from '~t';
import { useSelector, useDispatch } from 'react-redux';
import { set } from '~data/actions/config';

import { Title, Radio, SubLabel } from '~ui';

export default function SettingsBrowserExtensionMode() {
  const browser_extension_mode = useSelector(
    (state) => state.config.browser_extension_mode,
  );
  const dispatch = useDispatch();

  return (
    <>
      <Title>{t.s('appearance')}</Title>
      <div className={'ui-extmode-items'}>
        {[
          [
            'mini_app',
            t.s('miniApp'),
            t.s('miniAppD'),
            require('./mini_app.svg?component').default,
          ],
          [
            'clipper',
            'Clipper',
            t.s('clipperD'),
            require('./clipper.svg?component').default,
          ],
        ].map(([key, title, desc, Picture]) => (
          <div
            key={key}
            className={'ui-extmode-item'}
            onClick={() => dispatch(set('browser_extension_mode', key))}
          >
            <Picture
              className={'ui-extmode-picture'}
              data-active={browser_extension_mode == key}
            />

            <Radio
              checked={browser_extension_mode == key}
              readOnly
              name='browser_extension_mode'
            >
              {title}
            </Radio>

            <SubLabel>{desc}</SubLabel>
          </div>
        ))}
      </div>
    </>
  );
}
